import React, { useState, useEffect } from 'react'
import { Paper, Typography, useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'

function ContactForm({ isMobile }) {
  return (
    <div style={{ width: "100%", maxWidth: 640 }}>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSdtE3PE6xANdFGkQey4P7gnGoULldWVE6tVjMgIIxLSllP27A/viewform?embedded=true"
        style={{ width: "100%", border: 0 }}
        height="830" frameBorder="0" marginHeight="0" marginWidth="0">Loading…</iframe>
    </div>
  )
}

function Address({ isMobile }) {
  return (
    <Paper style={{
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      gap: isMobile ? 16 : 100,
      padding: 20
    }}>
      <Typography align="left">
        <b>Our Mailing Address</b><br/>
        San Pedro Association<br/>
        PO Box 885<br/>
        West Sacramento, CA 95605
      </Typography>
      <Typography align="left">
        <b>Our Street Address</b><br/>
        San Pedro Park<br/>
        708 N. Hobson Ave.<br/>
        West Sacramento, CA 95605
      </Typography>
    </Paper>
  )
}

export default function ContactUsPage() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <div className='faded-background' style={{
      "--b": `url(${require("../assets/SanPedroPark4.jpg")})`,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: 20,
      paddingLeft: isMobile ? 12 : 0,
      paddingRight: isMobile ? 12 : 0,
      gap: 20,
      width: "100%",
      boxSizing: "border-box"
    }}>
      <Address isMobile={isMobile} />
      <ContactForm isMobile={isMobile} />
    </div>
  )
}